// extracted by mini-css-extract-plugin
export default {"ledger-item":"styles_ledger-item__r+FY1"};